import React, { Component } from "react";
import { Button, CustomInput, Jumbotron } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { sortBy, isObject } from "lodash";
import TreeView from "../common/TreeView";
import { db } from "../common/firebase";
import settings from "../../settings.json";
import { getUserProfile, sendValidationEmail, saveAccess, deleteUser } from "../common/helper";
import Loading from "../pages/Loading";
import UserData from "../common/userData";
import Header from "../common/header";
import NavBar from "../navBar/navBar";

import "./UserAdministration.css";

export default class UserAdministration extends Component {
  state = {
    optionsUnsubscribe: () => {},
    availableTree: "",
    selectedUserData: null,
    loading: false,
    canSeeFinance: false,
    isAdmin: false,
    canSave: false,
    canPublish: false,
    canDownloadBase: false
  };

  deleteUser = selectedUserData => {
    toast.info(
      <div>
        <div>
          <FontAwesomeIcon icon={["fas", "exclamation-circle"]} size="2x" /> <h5>Are you sure you want to delete?</h5>
        </div>
        <div>
          <Button onClick={() => deleteUser(selectedUserData)} color="danger">
            YES
          </Button>
          {"        "}
          <Button onClick={() => toast.done("deletePrompt", 100)}>NO</Button>
        </div>
      </div>,
      {
        toastId: "deletePrompt",
        closeOnClick: false,
        className: {
          top: 40
        }
      }
    );
  };

  onChange = access => {
    this.setState({ access });
  };

  componentWillMount = () => {
    this.getUsers();
    this.getAvailableOptions();
  };

  getUsers = () => {
    this.setState({ loading: true });
    const { API_URL } = settings;
    axios
      .get(`${API_URL}/getUsers`)
      .then(listUsersResult => {
        const result = [];
        const emails = [];
        if (listUsersResult && listUsersResult.data)
          listUsersResult.data.users.forEach(userRecord => {
            result.push(userRecord);
            if (userRecord.email) emails.push(userRecord.email);
          });
        this.setState({ users: result, emails: sortBy(emails) });
        this.setState({ loading: false });
      })
      .catch(error => {
        this.setState({ loading: false });
        toast.error("Error listing users:", error);
      });
  };

  userClicked = user => {
    this.getUserAccess(user.email);
    this.setState({ selectedUserData: user });
  };

  getUserAccess = email => {
    getUserProfile(email)
      .then(doc => {
        let data = null;
        if (doc) data = doc.data();
        if (data) {
          const { access = [], canSeeFinance, isAdmin, canSave, canPublish, canDownloadBase } = data;
          let newAccess = access;
          if (!isObject(newAccess)) newAccess = JSON.parse(access);

          this.setState({ access: newAccess, canSeeFinance, isAdmin, canSave, canPublish, canDownloadBase });
        } else {
          this.setState({
            access: [],
            canSeeFinance: false,
            isAdmin: false,
            canSave: false,
            canPublish: false,
            canDownloadBase: false
          });
        }
      })
      .catch(err => {
        toast.error(err.message);
      });
  };

  getAvailableOptions = () => {
    this.setState({ loading: true });
    let { optionsUnsubscribe } = this.state;

    optionsUnsubscribe();

    optionsUnsubscribe = db.doc(`admin/1`).onSnapshot(snapshot => {
      const data = snapshot.data();
      if (data && data.availableTree) {
        const { availableTree = {} } = data;
        const availableTreeObj = isObject(availableTree) ? availableTree : JSON.parse(availableTree);
        this.setState({ availableTree: availableTreeObj });
      }

      this.setState({ loading: false });
    });

    this.setState({ optionsUnsubscribe });
  };

  render() {
    const {
      users,
      selectedUserData,
      loading,
      access,
      canSeeFinance,
      isAdmin,
      canSave,
      canPublish,
      canDownloadBase,
      emails,
      availableTree
    } = this.state;

    const { logOut } = this.props;

    if (loading) return <Loading />;

    return (
      <div className="UserAdministration">
        <ToastContainer />
        <div className="NavBar">
          <div className="realNavBar">
            <NavBar
              options={emails}
              showGlobal={false}
              authenticated
              selected={selectedUserData && selectedUserData.email}
              logOut={logOut}
              onClick={item => {
                const selectedUser = users.find(user => user.email === item);
                this.userClicked(selectedUser);
              }}
              canSave={false}
              canPublish={false}
              canDownloadBase={false}
              isAdmin={false}
            />
          </div>
        </div>
        <div className="Header">
          <Header label="User Administration" goBackPath="/" />
        </div>
        {!selectedUserData ? (
          <div className="Empty">
            <Jumbotron>
              <h5>Please select a user</h5>
            </Jumbotron>
          </div>
        ) : (
          ""
        )}

        {selectedUserData ? (
          <div className="Tree">
            <h4>Access Tree</h4>
            <TreeView treeData={availableTree} onChange={this.onChange} selectedValues={access} />{" "}
          </div>
        ) : (
          ""
        )}

        {selectedUserData && selectedUserData.providerData[0].providerId ? (
          <div className="UserInformation">
            <h4>User Information</h4>
            <div className="innerContent">
              <UserData
                user={selectedUserData}
                sendValidationEmail={sendValidationEmail}
                providerId={selectedUserData.providerData[0].providerId}
              />
            </div>
          </div>
        ) : (
          ""
        )}
        {selectedUserData ? (
          <div className="Visibility">
            <h4>Visibility</h4>
            <div className="innerContent">
              <CustomInput
                type="checkbox"
                name="canSeeFinance"
                id="canSeeFinance"
                label="Can see finance"
                checked={!!canSeeFinance}
                onChange={e => this.setState({ canSeeFinance: e.target.checked })}
              />
              <CustomInput
                type="checkbox"
                id="isAdmin"
                name="isAdmin"
                label="Is Admin"
                checked={!!isAdmin}
                onChange={e => this.setState({ isAdmin: e.target.checked })}
              />
              <CustomInput
                type="checkbox"
                id="canPublish"
                name="canPublish"
                label="Can Publish"
                checked={!!canPublish}
                onChange={e => this.setState({ canPublish: e.target.checked })}
              />

              <CustomInput
                type="checkbox"
                id="canSave"
                name="canSave"
                label="Can Save"
                checked={!!canSave}
                onChange={e => this.setState({ canSave: e.target.checked })}
              />
              <CustomInput
                type="checkbox"
                id="canDownloadBase"
                name="canDownloadBase"
                label="Can Download Base"
                checked={!!canDownloadBase}
                onChange={e => this.setState({ canDownloadBase: e.target.checked })}
              />
            </div>
          </div>
        ) : (
          ""
        )}

        {selectedUserData ? (
          <div className="Actions">
            <h4>Actions</h4>
            <div className="innerContent buttonPanel">
              <Button
                onClick={() =>
                  saveAccess(
                    selectedUserData.email,
                    access,
                    canSeeFinance,
                    isAdmin,
                    canSave,
                    canPublish,
                    canDownloadBase
                  )
                }
              >
                Save Access
              </Button>
            </div>
          </div>
        ) : (
          ""
        )}

        {selectedUserData ? (
          <div className="delete">
            <h4>Danger!</h4>
            <div className="innerContent buttonPanel">
              <Button color="danger" onClick={() => this.deleteUser(selectedUserData)}>
                Delete User
              </Button>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
